import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import getTranslation from '../../../strings/i18n';
import SlideInModalPortal from 'syf-component-library/ui/patterns/SlideInModalPortal/SlideInModalPortal';
import useSafariToolbarDetection from '../../../hooks/use-safari-toolbar-detection';
import { ModalOptions } from '../../../typings/activity/modal-types';
import ActivityCancelPaymentModalFooter from '../cancel-payment/modal-footer';
import CancelPaymentModalHeader from '../cancel-payment/modal-header';
import ModalFooter from './footer';
import ModalHeader from './header';
var Modal = function (_a) {
    var children = _a.children, closeModal = _a.closeModal, currentModal = _a.currentModal, open = _a.open, pendingPayment = _a.pendingPayment, setCurrentModal = _a.setCurrentModal, transactionStatus = _a.transactionStatus, disputesButtonEnabled = _a.disputesButtonEnabled;
    useSafariToolbarDetection();
    var t = getTranslation().t;
    var closeModalFunction = function () {
        if (currentModal !== ModalOptions.cancelInitiated) {
            closeModal();
        }
    };
    var ariaLabelByCurrentModal = useMemo(function () {
        switch (currentModal) {
            case ModalOptions.default: {
                return t('activityDetails.activityDetailHeader');
            }
            case ModalOptions.cancelComplete: {
                return t('activityDetails.cancelPayment.paymentCanceledHeading');
            }
            case ModalOptions.cancelInitiated:
            case ModalOptions.cancelConfirm:
            case ModalOptions.cancelError: {
                return t('activityDetails.cancelPayment.cancelPaymentHeading');
            }
            default: {
                return t('activityDetails.activityDetailHeader');
            }
        }
    }, [currentModal, t]);
    return (_jsx(SlideInModalPortal, { ariaLabel: ariaLabelByCurrentModal, containerId: "mma-modal-container", id: "slide-in-modal-mma", isOpen: open, escapeModalHandler: closeModalFunction, header: pendingPayment ? (_jsx(CancelPaymentModalHeader, { closeModal: closeModal, currentModal: currentModal })) : (_jsx(ModalHeader, { closeModal: closeModal })), footer: pendingPayment ? (_jsx(ActivityCancelPaymentModalFooter, { closeModal: closeModal, currentModal: currentModal, setCurrentModal: setCurrentModal })) : (_jsx(ModalFooter, { closeModal: closeModal, transactionStatus: transactionStatus, disputesButtonEnabled: disputesButtonEnabled })), children: children }));
};
export default Modal;
//# sourceMappingURL=index.js.map